/**
 * Ce que l'écran dit après avoir affecté quelqu'un dont le matériel est associé (077).
 *
 * *Chris, 10/09/2026 : « lorsque tu affectes une personne, automatiquement tu mettras dans le VUL
 * le VUL associé dans la table ».*
 *
 * **Le véhicule posé n'a pas besoin d'être annoncé** — il apparaît sur sa ligne au rechargement,
 * et une phrase qui répète ce qu'on voit devient du bruit qu'on cesse de lire. Il l'est quand
 * même, en une ligne, parce que la ligne d'atterrissage n'est **pas** celle qu'on vient de
 * remplir : on cherche sinon le véhicule ailleurs dans le tableau.
 *
 * **Ce qui n'a PAS été posé doit être dit.** C'est le cas qui se lit comme une panne : le
 * responsable a rempli sa table d'association, il affecte quelqu'un, et rien n'arrive. Sans un
 * mot, il ira chercher le défaut dans l'écran d'administration où tout est pourtant juste — alors
 * que la vraie réponse est « ce chantier ne chiffre pas de VUL ce jour-là ».
 */

export type Associe = {
  readonly poses: readonly { readonly libelle: string; readonly ligne: string }[];
  readonly ecartes: readonly { readonly libelle: string; readonly raison: string }[];
} | null;

/** La phrase, ou `null` quand il n'y a rien à dire — le cas de loin le plus fréquent. */
export function direLAssociation(associe: Associe): string | null {
  if (associe === null) return null;
  const morceaux: string[] = [];
  if (associe.poses.length > 0) {
    morceaux.push(
      `Posé avec : ${associe.poses.map((p) => `${p.libelle} sur ${p.ligne}`).join(", ")}.`,
    );
  }
  if (associe.ecartes.length > 0) {
    morceaux.push(
      `Non posé : ${associe.ecartes.map((e) => `${e.libelle} — ${e.raison}`).join(", ")}.`,
    );
  }
  return morceaux.length === 0 ? null : morceaux.join(" ");
}
